const localEpochToUTC = (epochInSeconds) => {
	const localDate = new Date(epochInSeconds * 1000);
	const timezoneOffset = localDate.getTimezoneOffset() * 60000;
	const utcEpochMillis = localDate.getTime() + timezoneOffset;

	return Math.floor(utcEpochMillis / 1000);
};

export default localEpochToUTC;
